import AffordabilityDeck from './affordability';
import PreapprovalDeck from './preapproval';
import PurchaseDeck from './purchase';
import QualifyDeck from './qualify';
import RefiFullDeck from './refi-full';
import RefiQualifyDeck from './refi-qualify';

export const chooseDeck = ({ scenario }) => {
  switch (scenario) {
    case 'Preapproval':
      return PreapprovalDeck;
    case 'Qualify':
      return QualifyDeck;
    case 'RefiFull':
      return RefiFullDeck;
    case 'RefiQualify':
      return RefiQualifyDeck;
    case 'Affordability':
      return AffordabilityDeck;
    case 'Purchase':
      return PurchaseDeck;
    default:
      throw new Error(`Unknown scenario ${scenario}`);
  }
};



// WEBPACK FOOTER //
// ./src/decks/index.js